import {FaArrowTrendUp, FaChartLine, FaChartPie, FaGoogle, FaMoneyBillWave, FaScaleBalanced} from "react-icons/fa6";
import React, {useEffect} from "react";
import {FaBitcoin, FaChartArea, FaCoins, FaDollarSign, FaEthereum, FaExchangeAlt, FaSignal} from "react-icons/fa";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import {setToken} from "../../redux/slices/loginSlice";
import axios from "axios";
import {useDispatch} from "react-redux";


export default function LoadingForLogin() {

    const [searchParams] = useSearchParams();
    const token = searchParams.get("accessToken")
    const dispatch = useDispatch();
    const navigate = useNavigate();


    useEffect(() => {

        const timeId = setInterval(() => {
            dispatch(setToken(token));
            axios.defaults.headers.common.Authorization = `Bearer ${token}`;
            navigate("/profile");
        }, 1500);
        return () => clearInterval(timeId);

    }, [searchParams])

    // Background icons
    const bgIcons = [
        {
            Icon: FaBitcoin,
            className: "text-yellow-300/40",
            style: {top: "6%", left: "4%", animationDelay: "0s", fontSize: 20}
        },
        {
            Icon: FaDollarSign,
            className: "text-white",
            style: {top: "14%", right: "8%", animationDelay: "0.6s", fontSize: 20}
        },
        {
            Icon: FaEthereum,
            className: "text-white/90",
            style: {top: "16%", left: "7%", animationDelay: "1.2s", fontSize: 18}
        },
        {
            Icon: FaChartLine,
            className: "text-white/55",
            style: {top: "20%", right: "6%", animationDelay: "1.8s", fontSize: 26}
        },
        {
            Icon: FaCoins,
            className: "text-white/70",
            style: {bottom: "72%", right: "8%", animationDelay: "0.9s", fontSize: 18}
        },
        {
            Icon: FaSignal,
            className: "text-white/70",
            style: {bottom: "15%", left: "3%", animationDelay: "2.2s", fontSize: 26}
        },
        {
            Icon: FaChartArea,
            className: "text-white/60",
            style: {bottom: "16%", right: "10%", animationDelay: "1.4s", fontSize: 18}
        },
        {
            Icon: FaChartPie,
            className: "text-white/60",
            style: {top: "96%", left: "10%", animationDelay: "2.5s", fontSize: 22}
        },
        {
            Icon: FaMoneyBillWave,
            className: "text-white/60",
            style: {top: "22%", left: "10%", animationDelay: "2.5s", fontSize: 18}
        },
        {
            Icon: FaChartLine,
            className: "text-white/60",
            style: {top: "28%", left: "2%", animationDelay: "1.4s", fontSize: 22}
        },
        {
            Icon: FaExchangeAlt,
            className: "text-white/100",
            style: {top: "90%", left: "2%", animationDelay: "1.8s", fontSize: 15}
        },
        {
            Icon: FaArrowTrendUp,
            className: "text-black",
            style: {top: "90%", left: "92%", animationDelay: "3.5s", fontSize: 15}
        },
        {
            Icon: FaScaleBalanced,
            className: "text-yellow-900/90",
            style: {top: "70%", left: "92%", animationDelay: "4.5s", fontSize: 20}
        },
    ];

    return (
        <div className="relative min-h-screen overflow-hidden bg-gray-50 font-inter">
            <div className="gradient-bg">
                <div className="trading-pattern"></div>
                {/* signal waves and floating icons remain the same */}
                {bgIcons.map((it, idx) => {
                    const {Icon, className, style} = it;
                    return (
                        <div
                            key={idx}
                            className={`floating-animation ${className}`}
                            style={{
                                position: "absolute",
                                opacity: idx === 0 ? 0.95 : 0.18,
                                ...style,
                            }}
                        >
                            <Icon/>
                        </div>
                    );
                })}
            </div>

            <div className="relative z-10 flex flex-col items-center justify-center py-4 min-h-full px-6">
                {/* Header / Logo */}
                <div className="text-center animate-fade-in">
                    <div
                        className="inline-flex items-center justify-center w-16 h-16 bg-white rounded-full shadow-lg mb-2 animate-pulse">
                        <FaChartLine className="text-2xl text-blue-600"/>
                    </div>
                    <h1 className="text-2xl font-bold text-white mb-1">7 Trade</h1>
                    <p className="text-blue-100 text-xs">Trade Signal Navigator</p>
                </div>

                <div
                    className="w-[350px] md:w-[500px] max-w-sm bg-white rounded-3xl shadow-2xl p-6 animate-slide-up scale-90">
                    <div className="space-y-6">
                        <div className="text-center mb-6">
                            <h2 className="text-2xl font-bold text-gray-800 mb-2">Just Moment</h2>
                        </div>


                        <div className="space-y-2 flex items-center justify-center">
                                Loading...
                        </div>


                    </div>
                </div>
            </div>
        </div>
    )
}